import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userReducer';

export const reducer = configureStore({
    reducer: {
        user: userReducer
    }
});
